import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';

export const GlobalStoreContext = React.createContext();

export const GlobalStoreProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [gameParticipants, setGameParticipants] = useState([]);


  useEffect(() => {

    // setGamePariticipants from localStorage
    localStorage.getItem('gameParticipants') && setGameParticipants(JSON.parse(localStorage.getItem('gameParticipants')));


    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  function clearPgStorage() {
    setGameParticipants([]);
  }

  useEffect(() => {
    if (!isOnline) toast.error('You are offline');
  }, [isOnline]);

  const value = {
    gameParticipants,
    setGameParticipants,
  };

  return <GlobalStoreContext.Provider value={value}>{children}</GlobalStoreContext.Provider>;
};

GlobalStoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
